import { usePersonalisationContext } from '../../../context/PersonalisationContext';
import { useLocale } from '../../../context/LocaleContext';

export interface EditorChrome {
  /** The Personalisation's header design; V1 unless it is set to V2 (as PersonalisationModal reads it). */
  headerStyle: 'V1' | 'V2';
  totalSteps: number;
  /** Index of the current step, -1 before one is set (the header clamps it). */
  currentStep: number;
  /** The journey's current total, formatted for the store's currency. */
  totalPrice: string;
}

/**
 * What the photo editor needs from the journey to look like one of its screens: the header
 * style, where the customer is in the steps, and the running total.
 */
export function useEditorChrome(): EditorChrome {
  const { personalisation, personalisationSteps, currentStepId, currentTotalPrice } = usePersonalisationContext();
  const { formatPrice } = useLocale();
  const stepIds: string[] = personalisationSteps ? Array.from(personalisationSteps.keys()) : [];

  return {
    headerStyle: personalisation?.headerStyle === 'V2' ? 'V2' : 'V1',
    totalSteps: stepIds.length,
    currentStep: stepIds.indexOf(currentStepId),
    totalPrice: formatPrice({ amount: currentTotalPrice ?? 0 })
  };
}
